import React, { Dispatch, SetStateAction } from 'react';
import Modal from '../modal/Modal';
import { Body2Regular, Body3Regular, Subtitle1Bold } from '../../lib/font';
import { Col, Row } from '../../lib/utils';
import { CodeValueType } from '../../types/types';
import SvgIcon from '../SvgIcon';
import { colors } from '../../lib/colors';
import NewColorSquareButton from '../Button/NewColorSquareButton';
import NewWhiteSquareButton from '../Button/NewWhiteSquareButton';
import NewTextInputDropDown from '../DropDown/NewTextInputDropDown';
type Props = {
    setIsVisible: Dispatch<SetStateAction<boolean>>;
    dropDownCoachList?: CodeValueType[];
    selectCoach?: CodeValueType;
    onClickChangeCoach: (newCoachId: string) => void;
    selectedMemberCount?: number;
    isSubmitting?: boolean;
};

const ModalTrainerInfomationMemberListMultiCoachChange = ({
    setIsVisible,
    dropDownCoachList,
    selectCoach: _selectCoach,
    onClickChangeCoach,
    selectedMemberCount,
    isSubmitting = false,
}: Props) => {
    const [selectCoach, setSelectCoach] = React.useState<CodeValueType | undefined>(_selectCoach);
    return (
        <Modal
            whiteViewWidth={1000}
            whiteViewHeight={460}
            isCloseButton
            onClose={() => {
                if (!isSubmitting) setIsVisible(false);
            }}
            isCloseOutside={!isSubmitting}
        >
            <Col className="py-[36px] px-[48px]">
                <Subtitle1Bold className=" text-LAVEL_4 mb-[16px]">
                    담당 강사 일괄 변경 [ 선택된 회원 수 : {selectedMemberCount ?? 0} 명 ]{' '}
                </Subtitle1Bold>
                <Body3Regular className="text-LAVEL_3 mb-[32px]">
                    변경할 강사님을 선택하시고 주의사항을 읽은 후, ‘변경하기'를 눌러주세요!
                </Body3Regular>
                <NewTextInputDropDown
                    selectData={selectCoach}
                    datas={dropDownCoachList ?? []}
                    onClickSort={(data) => {
                        setSelectCoach(data);
                    }}
                    width={300}
                    fontType={'Body2Regular'}
                    mb={40}
                />

                <Row className=" items-center mb-[8px]">
                    <SvgIcon name={'SvgError'} size={18} fill={colors.red} className="mr-[12px]" />
                    <Body2Regular className=" text-LAVEL_4">강사님이 변경되면 바뀌는 내용을 확인해 주세요!</Body2Regular>
                </Row>
                <Col className="pl-[32px]">
                    <Body3Regular className="text-LAVEL_2">
                        • 이전 강사님과 잡혀 있던 미래 수업 일정이 취소돼요.
                    </Body3Regular>
                    <Body3Regular className="text-LAVEL_2">
                        • 과거 수업 일정, 운동일지, 컨디션 정보 등의 데이터는 회원님이 그대로 확인할 수 있어요.
                    </Body3Regular>
                    <Body3Regular className="text-LAVEL_2">
                        • 이전 강사님 명의로 사용 중인 수강권만 새 담당 강사님께 인계 수강권으로 새로 생성돼요. 다른 강사님의 수강권은 그대로예요.
                    </Body3Regular>
                </Col>
                <Row className=" absolute bottom-[24px] right-[32px]">
                    <NewWhiteSquareButton
                        text="취소"
                        width={148}
                        height={48}
                        mr={16}
                        onClick={() => {
                            if (!isSubmitting) setIsVisible(false);
                        }}
                    />
                    <NewColorSquareButton
                        text={isSubmitting ? '변경 중...' : '변경하기'}
                        width={148}
                        height={48}
                        bgColor={'primary'}
                        textColor={'white'}
                        disabled={isSubmitting || !selectCoach?.code}
                        onClick={() => {
                            if (isSubmitting || !selectCoach?.code) return;
                            onClickChangeCoach(selectCoach.code);
                        }}
                    />
                </Row>
            </Col>
        </Modal>
    );
};

export default ModalTrainerInfomationMemberListMultiCoachChange;
